/**
 * Date-extensions locale Arabic (Algeria) [ar-dz]
 */
import DateExtended from "../date-extended";
DateExtended.addLocale('ar-dz', {
    monthNames: ['جانفي','فيفري','مارس','أفريل','ماي','جوان','جويلية','أوت','سبتمبر','أكتوبر','نوفمبر','ديسمبر'],
    monthShortNames: ['جانفي','فيفري','مارس','أفريل','ماي','جوان','جويلية','أوت','سبتمبر','أكتوبر','نوفمبر','ديسمبر'],
    dayNames: ['الأحد','الإثنين','الثلاثاء','الأربعاء','الخميس','الجمعة','السبت'],
    dayShortNames: ['احد','اثنين','ثلاثاء','اربعاء','خميس','جمعة','سبت']
});
